/**
 * K Formula Custom Theme - Theme Javascript Engine
 * Handles Ajax Cart, Drawer Toggles, Micro-interactions, and Accordions.
 */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initMobileNav();
  initAccordions();
  initStickyHeader();
  initScrollReveals();
  initCardQuantityControllers();
});

/* Lightweight Scroll Reveal Controller (Performance Optimized) */
function initScrollReveals() {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target); // Runs once, 0 ongoing CPU/memory cost!
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -40px 0px'
  });

  document.querySelectorAll('[data-reveal], [data-reveal-group], section').forEach(el => {
    if (!el.hasAttribute('data-reveal') && !el.hasAttribute('data-reveal-group')) {
      el.setAttribute('data-reveal', 'fade-up');
    }
    observer.observe(el);
  });
}

/* Sticky Header Scroll Controller */
function initStickyHeader() {
  const header = document.querySelector('.header-navbar');
  if (!header) return;

  function handleScroll() {
    if (window.scrollY > 60) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* Global Cart Open / Close Helpers */
function openCart() {
  const mobileNav = document.getElementById('MobileNavDrawer');
  const mobileOverlay = document.getElementById('MobileNavOverlay');
  if (mobileNav) mobileNav.classList.remove('is-open');
  if (mobileOverlay) mobileOverlay.classList.remove('is-open');
  document.body.classList.remove('mobile-nav-locked');

  const cartDrawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  if (cartDrawer) cartDrawer.classList.add('is-active', 'is-open');
  if (overlay) overlay.classList.add('is-active', 'is-open');
  document.body.classList.add('cart-drawer-open');
  fetchCartData();
}
window.openCart = openCart;
window.openCartDrawer = openCart;

function closeCart() {
  const cartDrawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  if (cartDrawer) cartDrawer.classList.remove('is-active', 'is-open');
  if (overlay) overlay.classList.remove('is-active', 'is-open');
  document.body.classList.remove('cart-drawer-open');
}
window.closeCart = closeCart;
window.closeCartDrawer = closeCart;

/* Cart Drawer Controller */
function initCartDrawer() {
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const closeTriggers = document.querySelectorAll('[data-cart-close]');
  const overlay = document.getElementById('CartDrawerOverlay');

  cartTriggers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  closeTriggers.forEach(btn => btn.addEventListener('click', closeCart));
  if (overlay) overlay.addEventListener('click', closeCart);

  // Ajax Add to Cart Global Interceptor
  document.addEventListener('submit', async (e) => {
    if (e.target.matches('[data-type="add-to-cart-form"]')) {
      e.preventDefault();
      const form = e.target;
      const submitBtn = form.querySelector('[type="submit"]');

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.7';
      }

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (res.ok) {
          fetchCartData();
          openCart();
        } else {
          const err = await res.json();
          alert(err.description || 'Error adding item to cart.');
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      }
    }
  });
}



/* Helper: Format Money in Rs. */
function formatMoneyRs(cents) {
  const amount = (cents / 100).toFixed(2);
  return `Rs. ${amount}`;
}

/* Fetch & Render Cart Drawer Items */
async function fetchCartData(providedCart) {
  try {
    let cart = providedCart;
    if (!cart) {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      cart = await res.json();
    }

    // Update Cart Counter Badges & Red Dot Indicators
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.innerText = cart.item_count;
    });

    document.querySelectorAll('[data-cart-dot]').forEach(el => {
      if (cart.item_count > 0) {
        el.classList.remove('is-hidden');
        el.style.display = 'inline-block';
      } else {
        el.classList.add('is-hidden');
        el.style.display = 'none';
      }
    });

    // Update Product Card Quantity Controllers (+ 1 -)
    updateCardQuantityDisplay(cart);

    const itemsContainer = document.getElementById('CartDrawerItems');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    const shippingBarEl = document.getElementById('CartDrawerShippingBar');

    if (subtotalEl) {
      subtotalEl.innerText = formatMoneyRs(cart.total_price);
    }

    // Update Free Shipping Progress Bar (Hidden when empty, unlocked for any items)
    if (shippingBarEl) {
      if (cart.item_count === 0) {
        shippingBarEl.style.display = 'none';
      } else {
        shippingBarEl.style.display = 'block';
        shippingBarEl.innerHTML = `
          <div class="shipping-msg shipping-success">&#127881; You have unlocked <strong>FREE SHIPPING!</strong></div>
          <div class="shipping-bar"><div class="shipping-progress" style="width: 100%;"></div></div>
        `;
      }
    }

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div class="cart-empty-state">
          <p class="cart-empty-text">Your shopping cart is currently empty.</p>
          <a href="/collections/all" class="cart-explore-btn">EXPLORE PRODUCTS</a>
        </div>
      `;
      return;
    }

    let itemsHTML = '';
    cart.items.forEach(item => {
      const imgHTML = item.image 
        ? `<img src="${item.image}" alt="${item.product_title}" class="cart-item-img" />`
        : `<div class="cart-item-img-placeholder">KF</div>`;
      
      const variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="cart-item-variant">${item.variant_title}</div>`
        : '';

      const linePriceFormatted = formatMoneyRs(item.final_line_price);

      itemsHTML += `
        <div class="cart-item" data-key="${item.key}">
          ${imgHTML}
          <div class="cart-item-info">
            <div class="cart-item-header">
              <h4 class="cart-item-title">${(item.product_title || item.title).toUpperCase()}</h4>
              <button type="button" class="cart-item-remove" onclick="changeQty('${item.key}', 0)" aria-label="Remove item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>
            ${variantHTML}
            <div class="cart-item-bottom">
              <div class="cart-item-qty">
                <button type="button" onclick="changeQty('${item.key}', ${item.quantity - 1})" aria-label="Decrease quantity">-</button>
                <span>${item.quantity}</span>
                <button type="button" onclick="changeQty('${item.key}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
              </div>
              <div class="cart-item-price">${linePriceFormatted}</div>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHTML;
  } catch (e) {
    console.error('Error fetching cart:', e);
  }
}

/* Change Item Quantity (Exposed globally for inline onclick) */
async function changeQty(key, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (res.ok) {
      const updatedCart = await res.json();
      fetchCartData(updatedCart);
    }
  } catch (e) {
    console.error('Error changing qty:', e);
  }
}
window.changeQty = changeQty;

/* Mobile Nav Drawer Controller */
function initMobileNav() {
  const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
  if (toggleBtn && !toggleBtn.getAttribute('onclick')) {
    toggleBtn.addEventListener('click', (e) => {
      if (typeof window.toggleMobileMenu === 'function') {
        window.toggleMobileMenu(e);
      }
    });
  }
}

/* FAQ Accordion Controller */
function initAccordions() {
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      item.classList.toggle('is-open');
    });
  });
}

/* Product Card Dynamic Quantity Controller (+ 1 -) */
let cardQtyDebounceMap = {};

function initCardQuantityControllers() {
  document.addEventListener('click', async (e) => {
    const plusBtn = e.target.closest('.qty-btn-plus');
    const minusBtn = e.target.closest('.qty-btn-minus');

    if (plusBtn || minusBtn) {
      e.preventDefault();
      e.stopPropagation();

      const btn = plusBtn || minusBtn;
      const isPlus = !!plusBtn;

      const wrapper = btn.closest('.card-quantity-wrapper');
      if (!wrapper) return;
      const variantId = String(wrapper.dataset.variantId).trim();
      if (!variantId || variantId === 'blank') return;

      const numEl = wrapper.querySelector('.qty-num-text');
      let currentQty = parseInt(numEl ? numEl.innerText : (isPlus ? '0' : '1'), 10);
      if (isNaN(currentQty)) currentQty = isPlus ? 0 : 1;

      const nextQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);

      // 1. Instant 0ms Optimistic Screen Update (Zero Latency UI)
      if (numEl) {
        numEl.innerText = nextQty > 0 ? nextQty : '1';
      }

      // 2. Debounce Network Sync (Smooth Rapid Taps)
      if (cardQtyDebounceMap[variantId]) {
        clearTimeout(cardQtyDebounceMap[variantId]);
      }

      cardQtyDebounceMap[variantId] = setTimeout(async () => {
        const lineKey = wrapper.dataset.lineKey;
        if (lineKey) {
          await changeQty(lineKey, nextQty);
        } else if (isPlus) {
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10) || variantId, quantity: nextQty }] })
            });
            if (res.ok) {
              const updatedCart = await (await fetch('/cart.js')).json();
              fetchCartData(updatedCart);
            }
          } catch (err) {
            console.error('Quantity add error:', err);
          }
        }
      }, 150);
    }
  });

  updateCardQuantityDisplay();
}

/* Sync Product Card Cart State & Item Quantity Red Badge */
async function updateCardQuantityDisplay(cartData) {
  try {
    const cart = cartData || await (await fetch('/cart.js')).json();
    const qtyMap = {};
    if (cart && cart.items) {
      cart.items.forEach(item => {
        const vId = String(item.variant_id || item.id || '').trim();
        if (vId) {
          qtyMap[vId] = (qtyMap[vId] || 0) + item.quantity;
        }
      });
    }

    document.querySelectorAll('.card-quantity-wrapper').forEach(wrapper => {
      let variantId = String(wrapper.dataset.variantId || '').trim();
      if (!variantId) {
        const idInput = wrapper.querySelector('input[name="id"]');
        if (idInput) variantId = String(idInput.value).trim();
      }
      const qty = qtyMap[variantId] || 0;
      const submitBtn = wrapper.querySelector('.circular-cart-btn');

      if (!submitBtn) return;

      let badgeEl = submitBtn.querySelector('.card-cart-badge');

      if (qty > 0) {
        if (!badgeEl) {
          badgeEl = document.createElement('span');
          badgeEl.className = 'card-cart-badge';
          submitBtn.appendChild(badgeEl);
        }
        badgeEl.innerText = qty;
        badgeEl.classList.remove('is-hidden');
        badgeEl.style.display = 'flex';
      } else {
        if (badgeEl) {
          badgeEl.classList.add('is-hidden');
          badgeEl.style.display = 'none';
        }
      }
    });
  } catch (err) {
    console.error('Error syncing card quantity badge:', err);
  }
}
window.updateCardQuantityDisplay = updateCardQuantityDisplay;
window.updateCardBadges = updateCardQuantityDisplay;
